const notSelected = "no_selection";

export default notSelected;
